import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS =
  "saga/membershipBreakdown/FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS";
export const FETCH_CURRENT_USER_SUCCESS = "saga/membershipBreakdown/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER = "saga/membershipBreakdown/FETCH_CURRENT_USER";

export const SET_TABLE_LOADING = "saga/membershipBreakdown/SET_TABLE_LOADING";
export const SET_LOADING = "saga/membershipBreakdown/SET_LOADING";

export const UPDATE_GROUP_BY_REVENUE_CATEGORY =
  "saga/membershipBreakdown/UPDATE_GROUP_BY_REVENUE_CATEGORY";
export const UPDATE_INCLUDE_ZERO_SALES = "saga/membershipBreakdown/UPDATE_INCLUDE_ZERO_SALES";
export const UPDATE_CHART_SUCCESS = "saga/membershipBreakdown/UPDATE_CHART_SUCCESS";
export const UPDATE_CHART_FAILURE = "saga/membershipBreakdown/UPDATE_CHART_FAILURE";
export const UPDATE_STATUS_TYPES = "saga/membershipBreakdown/UPDATE_STATUS_TYPES";
export const UPDATE_DATE = "saga/membershipBreakdown/UPDATE_DATE";

export const RESET_FILTER_SELECTED = "saga/membershipBreakdown/RESET_FILTER_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDate: createAction(UPDATE_DATE),
  updateGroupBy: createAction(UPDATE_GROUP_BY_REVENUE_CATEGORY),
  updateIncludeZeroSales: createAction(UPDATE_INCLUDE_ZERO_SALES),
  updateStatusTypes: createAction(UPDATE_STATUS_TYPES)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_DATE, getMembershipBreakdown);
  yield takeLatest(UPDATE_GROUP_BY_REVENUE_CATEGORY, getMembershipBreakdown);
  yield takeLatest(UPDATE_INCLUDE_ZERO_SALES, getMembershipBreakdown);
  yield takeLatest(UPDATE_STATUS_TYPES, fetchModuleByStatusType);
}

export function* getCurrentUserData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: true });
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload });

    yield getMembershipBreakdown();
  } catch (error) {
    console.error(error);
  }
}
export function* fetchModuleByStatusType() {
  try {
    yield put({ type: SET_LOADING, payload: true });
    yield put({ type: RESET_FILTER_SELECTED });
    yield getMembershipBreakdown();
  } catch (error) {
    console.error(error);
  }
}

export function* getMembershipBreakdown() {
  yield put({ type: SET_TABLE_LOADING, payload: true });
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  const {
    date,
    selectedStatusTypes,
    selectedFilters: { groupBy, includeZeroSales }
  } = yield select((state) => state.membershipBreakdown);

  try {
    const membershipBreakdownResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/memberships/membership_breakdown",
      {
        params: {
          organization_id,
          short_url,
          date,
          group_by_revenue_category: groupBy.id,
          include_zero_sales: includeZeroSales.id,
          status_type: selectedStatusTypes.id
        }
      }
    );

    yield put({
      type: FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS,
      payload: membershipBreakdownResponse.data
    });
  } catch (error) {
    console.error(error);
  }
}
